import React, { Component } from "react";
import _ from "lodash";
import TextField from '@material-ui/core/TextField';
import AnalyticsTrackingClicks from "components/AnalyticsTrackingClicks";
import AnalyticsTrackingProfile from "components/AnalyticsTrackingProfile";
import AnalyticsTrackingRegister from "components/AnalyticsTrackingRegister";
import AnalyticsTrackingPosts from "components/AnalyticsTrackingPosts";

import Select from 'react-select';

const { DateTime } = require("luxon");

class AnalyticsByTracking extends Component {
    constructor(props) {
        super(props);

        this.tabSelectOptions = {
            clicks: { value: 1, label: "Clicks" },
            profile: { value: 2, label: "Profile" },
            posts: { value: 3, label: "Posts" },
            register: { value: 4, label: "Refer A Creator Clicks" },
        };

        this.state = {
            tab: 1,
            tabSelectOptions: {
                options: [
                    this.tabSelectOptions.clicks,
                    this.tabSelectOptions.profile,
                    this.tabSelectOptions.posts,
                    this.tabSelectOptions.register,
                ],
                defaultValue: this.tabSelectOptions.clicks,
                currentValue: this.tabSelectOptions.clicks,
            },
            // UTM checkbox state (camelCase)
            utmId: false,
            utmSource: false,
            utmMedium: false,
            utmName: false,
            utmContent: false,
            utmTerm: false,
        };
    }

    componentDidMount = async () => { };

    componentDidUpdate = (prevProps, prevState) => { };

    handleTabSortSelect = async (e) => {
        const tab = e.value;
        let tabSelectOptions = { ...this.state.tabSelectOptions };
        tabSelectOptions.currentValue = e;
        this.setState({ tab, tabSelectOptions });
    };

    // Toggle handler for UTM checkboxes
    handleUtmToggle = (key) => {
        this.setState((prev) => ({ [key]: !prev[key] }));
    };

    renderUtmCheckbox = (key, label) => (
        <label
            key={key}
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                fontFamily: "'Urbanist', sans-serif",
                fontSize: "0.95rem",
                userSelect: "none",
                whiteSpace: "nowrap",
            }}
            title={label}
        >
            <input
                type="checkbox"
                checked={this.state[key]}
                onChange={() => this.handleUtmToggle(key)}
                style={{ cursor: "pointer" }}
            />
            {label}
        </label>
    );

    render() {
        const isSm = ["sm"].includes(this.props.deviceSize);

        return (
            <div
                className="container pt-0 pb-5 px-0 px-md-3"
                style={{
                    display: this.props.display ? "" : "none",
                    fontFamily: "'Urbanist', sans-serif",
                }}
            >
                <div className={`${isSm ? "pt-2 ml-2" : ""}`}>
                    <div className="search-block">
                        <div
                            className={`mx-0  ${isSm ? "ml-2 mr-2" : ""
                                }`}
                            style={{ gap: "12px", flexWrap: "wrap" }}
                        >
                            {/* Left: tab select */}
                            <div style={{ position: "relative", top: "0", width: "250px" }}>
                                <Select
                                    isMulti={false}
                                    isClearable={false}
                                    isSearchable={false}
                                    blurInputOnSelect={true}
                                    captureMenuScroll={true}
                                    value={this.state.tabSelectOptions.currentValue}
                                    onChange={(e) => {
                                        this.handleTabSortSelect(e);
                                    }}
                                    options={this.state.tabSelectOptions.options}
                                />
                            </div>

                            {/* Right: UTM checkboxes */}
                            <div
                                className="mt-3"
                                style={{
                                    display: "flex",
                                    gap: isSm ? "0px 12px" : "0px 20px",
                                    alignItems: "flex-end",
                                    //justifyContent: isSm ? "flex-start" : "flex-end",
                                    flex: 1,
                                    flexWrap: "wrap"
                                }}
                            >
                                {this.renderUtmCheckbox("utmId", "utm_id")}
                                {this.renderUtmCheckbox("utmSource", "utm_source")}
                                {this.renderUtmCheckbox("utmMedium", "utm_medium")}
                                {this.renderUtmCheckbox("utmName", "utm_name")}
                                {this.renderUtmCheckbox("utmContent", "utm_content")}
                                {this.renderUtmCheckbox("utmTerm", "utm_term")}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Content by tab */}
                {this.state.tab === 1 ? (
                    <AnalyticsTrackingClicks
                        loggedInUser={this.props.loggedInUser}
                        deviceSize={this.props.deviceSize}
                        // You can pass the selections down if needed:
                        utmSelections={{
                            utmId: this.state.utmId,
                            utmSource: this.state.utmSource,
                            utmMedium: this.state.utmMedium,
                            utmName: this.state.utmName,
                            utmContent: this.state.utmContent,
                            utmTerm: this.state.utmTerm,
                        }}
                        userId={this.props.userId}
                        startDate={this.props.startDate}
                        endDate={this.props.endDate}
                    />
                ) : this.state.tab === 2 ? (
                    <AnalyticsTrackingProfile
                        loggedInUser={this.props.loggedInUser}
                        deviceSize={this.props.deviceSize}
                        utmSelections={{
                            utmId: this.state.utmId,
                            utmSource: this.state.utmSource,
                            utmMedium: this.state.utmMedium,
                            utmName: this.state.utmName,
                            utmContent: this.state.utmContent,
                            utmTerm: this.state.utmTerm,
                                }}
                        userId={this.props.userId}
                        startDate={this.props.startDate}
                        endDate={this.props.endDate}
                    />
                    ) : this.state.tab === 3 ? (
                        <AnalyticsTrackingPosts
                            loggedInUser={this.props.loggedInUser}
                            deviceSize={this.props.deviceSize}
                            utmSelections={{
                                utmId: this.state.utmId,
                                utmSource: this.state.utmSource,
                                utmMedium: this.state.utmMedium,
                                utmName: this.state.utmName,
                                utmContent: this.state.utmContent,
                                utmTerm: this.state.utmTerm,
                            }}
                            userId={this.props.userId}
                            startDate={this.props.startDate}
                            endDate={this.props.endDate}
                        />
                    ) : this.state.tab === 4 ? (
                        <AnalyticsTrackingRegister
                            loggedInUser={this.props.loggedInUser}
                            deviceSize={this.props.deviceSize}
                            utmSelections={{
                                utmId: this.state.utmId,
                                utmSource: this.state.utmSource,
                                utmMedium: this.state.utmMedium,
                                utmName: this.state.utmName,
                                utmContent: this.state.utmContent,
                                utmTerm: this.state.utmTerm,
                            }}
                            userId={this.props.userId}
                            startDate={this.props.startDate}
                            endDate={this.props.endDate}
                        />
                    ) : (
                    <></>
                )}
            </div>
        );
    }
}

export default AnalyticsByTracking;
